export default "/_next/static/chunks/fonts/Cabin-Bold-latin-7d4a4b5defeb0be20d8b80c60787727e.woff2";